import { createFileRoute } from '@tanstack/react-router';
import { RosterPage } from '@/features/shifts/pages/roster-page';

export const Route = createFileRoute('/_app/shifts/')({ component: RosterPage });
